export default __webpack_public_path__ + "static/media/Contract.375669b8.svg";